import { Card, CardBody, Col, ListGroup, ListGroupItem } from 'reactstrap'
import { WarningBorderState } from '../../../../utils/Constant'
import { borderWarningData } from '../../../../Data/BonusUi/CreativeCard/CreativeCard'
import CommonCardHeader from '../../../../CommonElements/CommonCardHeader/CommonCardHeader'

const BorderWarningState = () => {
  return (
    <Col xxl="4" md="6">
      <Card className="height-equal">
        <CommonCardHeader headClass="border-l-warning border-3" title={WarningBorderState} span={borderWarningData} />
        <CardBody className="mb-3">
          <ListGroup className='list-content-ui' numbered>
            <ListGroupItem className="txt-primary fw-bold" >known for delivery of useful and usable solutions</ListGroupItem>
            <ListGroupItem className="txt-danger fw-bold" >Solve your problem with us</ListGroupItem>
            <ListGroupItem className="text-success fw-bold" >Certified Professionals</ListGroupItem>
            <ListGroupItem className="txt-warning fw-bold" >Growth-Driven</ListGroupItem>
          </ListGroup>
        </CardBody>
      </Card>
    </Col>
  )
}

export default BorderWarningState